import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  flex-direction: column;
  gap: 20px;
  color: white;
`;

const AuthCallbackPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { handleCallback } = useAuth();

  useEffect(() => {
    const token = searchParams.get('token');
    const error = searchParams.get('auth_error');

    if (error) {
      console.error('Auth error:', error);
      navigate('/', { replace: true });
      return;
    }

    if (token) {
      handleCallback(token).then(() => {
        navigate('/', { replace: true });
      });
    } else {
      navigate('/', { replace: true });
    }
  }, [searchParams, handleCallback, navigate]);

  return (
    <Container>
      <motion.div
        animate={{ rotate: 360 }}
        transition={{ duration: 2, repeat: Infinity, ease: 'linear' }}
      >
        <Sparkles size={48} />
      </motion.div>
      <div>ログイン中...</div>
    </Container>
  );
};

export default AuthCallbackPage;
